export function denominators(decimal) {
	if (decimal % 1 === 0) {
		return { denominator: 1, numerator: decimal };
	}

	const tolerance = 1.0e-6;
	let numerator = 1,
		h2 = 0,
		denominator = 0,
		k2 = 1,
		b = decimal;

	do {
		const a = Math.floor(b);
		let aux = numerator;
		numerator = a * numerator + h2;
		h2 = aux;
		aux = denominator;
		denominator = a * denominator + k2;
		k2 = aux;
		b = 1 / (b - a);
	} while (Math.abs(decimal - numerator / denominator) > decimal * tolerance);

	return { denominator, numerator };
}

export function decimalToFraction(decimal) {
	const { denominator, numerator } = denominators(decimal);
	return `${numerator} / ${denominator}`;
}

export function minimumPixelSize(decimal) {
	const { denominator, numerator } = denominators(decimal);
	return {
		denominator: denominator * 15,
		numerator: numerator * 15,
	};
}

export function decodeString(str = "") {
	try {
		const output = decodeURIComponent(str);
		return output || "";
	} catch (error) {
		return str;
	}
}

export function encodeString(str = "") {
	try {
		const output = str;
		return output;
	} catch (error) {
		return str;
	}
}

export function calculateMinCropBoxSize(imageWidth, imageHeight, aspectRatio) {
	const { numerator: minPixelWidth, denominator: minPixelHeight } = minimumPixelSize(aspectRatio);
	const widthDecimal = minPixelWidth / imageWidth;
	const heightDecimal = minPixelHeight / imageHeight;
	const proportionDecimal = Math.max(widthDecimal, heightDecimal);

	return {
		minCropBoxWidth: imageWidth * proportionDecimal,
		minCropBoxHeight: imageHeight * proportionDecimal,
	};
}

export function sortByProperty(list = [], key, order = "asc") {
	return [...list].sort((a, b) => {
		const valueA = a[key];
		const valueB = b[key];

		if (valueA == null && valueB != null) return order === "asc" ? -1 : 1;
		if (valueA != null && valueB == null) return order === "asc" ? 1 : -1;
		if (valueA == null && valueB == null) return 0;

		if (typeof valueA === "string" && typeof valueB === "string") {
			const aTrimValue = valueA.trim();
			const bTrimValue = valueB.trim();
			return order === "asc"
				? aTrimValue.localeCompare(bTrimValue, undefined, { numeric: true, sensitivity: "base" })
				: bTrimValue.localeCompare(aTrimValue, undefined, { numeric: true, sensitivity: "base" });
		}

		if (typeof valA === "number" && typeof valB === "number") {
			return order === "asc" ? valueA - valueB : valueB - valueA;
		}

		return 0;
	});
}

export async function validTrainers({ domainGymId, coachesData, workoutCoach, createCoachTrigger }) {
	const invalidCoaches = workoutCoach?.filter((coach) => !coachesData?.coaches?.some((c) => c.id === coach));
	let validCoaches = workoutCoach?.filter((coach) => coachesData?.coaches?.some((c) => c.id === coach));
	if (invalidCoaches?.length) {
		const promises = invalidCoaches.map(async (coachName) => {
			// Find coach id by name
			const existingCoach = coachesData?.coaches?.find((c) => c.name?.toLowerCase() === coachName?.toLowerCase());
			if (existingCoach) {
				return existingCoach.id;
			}
			const formData = new FormData();
			formData.append("gym_id", domainGymId);
			formData.append("name", coachName);
			const response = await createCoachTrigger(formData).unwrap();
			return response?.coach?.id;
		});
		const coaches = await Promise.all(promises);
		validCoaches = [...validCoaches, ...coaches];
	}
	return validCoaches;
}

export async function validEquipments({ domainGymId, equipmentData, selectedEquipments, createEquipmentTrigger }) {
	const invalidEquipments = selectedEquipments?.filter(
		(equipment) => !equipmentData?.equipments?.some((e) => e.id === equipment)
	);
	let validEquipments = selectedEquipments?.filter((equipment) =>
		equipmentData?.equipments?.some((e) => e.id === equipment)
	);
	if (invalidEquipments?.length) {
		const promises = invalidEquipments.map(async (equipmentName) => {
			// Find equipment id by name
			const existingEquipment = equipmentData?.equipments?.find(
				(e) => e.name?.toLowerCase() === equipmentName?.toLowerCase()
			);
			if (existingEquipment) {
				return existingEquipment.id;
			}
			const response = await createEquipmentTrigger({
				name: equipmentName,
				gym_id: domainGymId,
			}).unwrap();
			return response?.equipment?.id;
		});
		const equipments = await Promise.all(promises);
		validEquipments = [...validEquipments, ...equipments];
	}
	return validEquipments;
}

